// src/components/Dashboard/AdminMember.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';
import ApplicationModal from './ApplicationModal';

const AdminMember = () => {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'memberApplications'));
        const apps = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          console.log('Member Application Data:', data); // Debug log to inspect raw data
          const mappedData = {
            id: doc.id, 
            type: 'member', 
            name: data.fullNames || data.fullName || 'N/A', 
            fullNames: data.fullNames || data.fullName || 'N/A',
            personalEmail: data.personalEmailAddress || data.personalEmail || data.email || 'N/A',
            contactCallMain: data.contactNumbersCallsMain || data.contactNumbersCallsMain || data.contactNumber || data.phone || 'N/A',
            submittedAt: data.submittedAt || data.createdAt || data.dateSubmitted || null,
            ...data 
          };
          // Handle submittedAt format if it's a Date object (fallback for non-Timestamp)
          if (mappedData.submittedAt && !(mappedData.submittedAt.seconds !== undefined)) {
            // If it's a plain Date, convert to Timestamp-like structure for consistency
            const date = new Date(mappedData.submittedAt);
            mappedData.submittedAt = { seconds: Math.floor(date.getTime() / 1000) };
          }
          apps.push(mappedData);
        });
        setApplications(apps);
        setFilteredApplications(apps);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching member applications:', error);
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  useEffect(() => {
    const filtered = applications.filter(app => 
      app.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (app.personalEmail && app.personalEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (app.contactCallMain && app.contactCallMain.includes(searchTerm))
    );
    setFilteredApplications(filtered);
  }, [searchTerm, applications]);

  const viewApplicationDetails = (application) => {
    setSelectedApplication(application);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedApplication(null);
  };

  if (loading) {
    return <div className="loading">Loading member applications...</div>;
  }

  return (
    <div className="dashboard-section">
      <h3>Member Applications ({applications.length})</h3>
      
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by name, email, or phone number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Submitted Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredApplications.map(application => {
              // Robust date handling
              let submittedDate = 'N/A';
              if (application.submittedAt) {
                if (application.submittedAt.seconds !== undefined) {
                  submittedDate = new Date(application.submittedAt.seconds * 1000).toLocaleDateString();
                } else if (typeof application.submittedAt === 'string') {
                  submittedDate = new Date(application.submittedAt).toLocaleDateString();
                } else if (application.submittedAt instanceof Date) {
                  submittedDate = application.submittedAt.toLocaleDateString();
                }
              }
              return (
                <tr key={`member-${application.id}`}>
                  <td>
                    <span className="type-badge type-member">Member</span>
                  </td>
                  <td>{application.fullNames || 'N/A'}</td>
                  <td>{application.personalEmail || 'N/A'}</td>
                  <td>{application.contactCallMain || 'N/A'}</td>
                  <td>{submittedDate}</td>
                  <td>
                    <span className={`status-badge status-${application.status || 'pending'}`}>
                      {application.status || 'Pending'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-primary"
                      onClick={() => viewApplicationDetails(application)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filteredApplications.length === 0 && (
          <p className="no-data">
            {searchTerm ? 'No matching member applications found.' : 'No member applications found.'}
          </p>
        )}
      </div>

      {showModal && selectedApplication && (
        <ApplicationModal 
          application={selectedApplication} 
          onClose={closeModal} 
        />
      )}
    </div>
  );
};

export default AdminMember;